/**
*
* Dictionary for all the colors used in the app.
*
* Do not add colors elsewhere. Having them centrally is nice.
*/
export default {
  background: 'rgb(87,112,145)',
  titleText: 'rgba(137,246,250, 0.9)',
  text: 'rgba(126,226,230, 0.8)',
  teardrop: 'rgba(247,165,59, 0.3)',
  inklinationLine: 'rgba(247,165,59, 0.7)',
  teardropLine: 'rgba(247,165,59, 0.7)',
  overlay: 'rgba(0,0,0, 0.3)',
  cta: 'rgba(30,100,154, 1)',
  buttonText: 'rgba(255,255,255, 0.7)',
  errorButton: 'rgba(197,70,38, 1)',
  entry: 'rgba(255,255,255, 0.3)',
  controlButton: 'rgba(0,0,0, 0.3)'
}



// WEBPACK FOOTER //
// ./src/colors.js